import { Audiowork } from './Audiowork';
import Devportfolio from './Devportfolio';

export const Portfolio = () => {
  return (
    <section id="portfolio" className="bg-black py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <p className="text-red-500 font-mono text-xs uppercase tracking-widest text-center mb-3">What I do</p>
        <h2 className="text-4xl font-bold text-white text-center mb-16">Portfolio</h2>
        <Devportfolio />
        <div className="border-t border-neutral-800 my-16" />
        <Audiowork />
      </div>
    </section>
  );
};
